import React, { useState, useEffect } from 'react';
import {
    Card, CardContent, Typography, Button, TextField, Autocomplete, Table, TableBody, TableCell, Container, Stack, Box, TableContainer, TableHead, TableRow, Paper, CircularProgress, Backdrop
} from '@mui/material';
import { saveAs } from 'file-saver';
import Grid from '@mui/material/Grid';
import * as XLSX from 'xlsx';
import { blue } from '@mui/material/colors';
import axios from 'axios';
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';

const styles = {
    tableContainer: {
        width: '100%',
        maxHeight: '400px',
        overflowY: 'auto',
    },
    headerCell: {
        fontWeight: 'bold',
        backgroundColor: blue[300],
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '1rem',
    },
    bodyCell: {
        padding: '12px 16px',
        textAlign: 'center',
        fontSize: '0.875rem',
    },
    tableRow: (index) => ({
        backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#ffffff',
    }),
};

const Report = () => {
    const [reportType, setReportType] = useState("");
    const [financialYear, setFinancialYear] = useState("");
    const [psg, setPsg] = useState(null);
    const [reportProcessed, setReportProcessed] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [psgOptions, setPsgOptions] = useState([]);
    const [branchOptions, setBranchOptions] = useState([]);
    const [financialYears, setFinancialYears] = useState([]);
    const [dealerOptions, setDealerOptions] = useState([]);
    const [branch, setBranch] = useState(null);
    const [dealer, setDealer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");
    const [reportDataError, setReportDataError] = useState('');
    const [selectedYear, setSelectedYear] = useState('');

    const handlePsgChange = (e, value) => setPsg(value);
    const handleReportTypeChange = (value) => fetchPsgOptions();
    const handleFinancialYearChange = (e, value) => setFinancialYear(value);
    const handleBranchChange = (event, newValue) => {
        setBranch(newValue);
        if (newValue) {
            fetchDealerOptions(newValue.BRANCH_CODE);
        }
    };
    const handleDealerChange = (event, newValue) => {
        setDealer(newValue);
    };

    const handleApiError = (err) => {
        const errorMessage = err?.response?.data?.message || "An error occurred.";
        setError(errorMessage);
    };

    const fetchFinancialYears = async () => {
        try {
            const response = await axios.post(BASE_URL + '/generatefinancialyears');
            setFinancialYears(response.data.fyear);
        } catch (err) {
            setError(err.message);
        }
    };

    const fetchPsgOptions = async () => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + '/getpsgoptions');
            if (response.data?.psglist) {
                setPsgOptions(response.data.psglist);
            } else {
                setError("No PSG options available.");
            }
        } catch (err) {
            handleApiError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBranchOptions = async () => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + '/getbranchoptions');
            if (response.data?.branchlist) {
                setBranchOptions(response.data.branchlist);
            } else {
                setError("No Branch options available.");
            }
        } catch (err) {
            handleApiError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchDealerOptions = async (branchCode) => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + '/getdealeroptions', { branch: branchCode });
            if (response.data?.dealerList) {
                setDealerOptions(response.data.dealerList);
            } else {
                setError("No Dealer options available.");
            }
        } catch (err) {
            handleApiError(err);
        } finally {
            setLoading(false);
        }
    };

    // const fetchReportData = async () => {
    //     setLoading(true);
    //     setError("");
    //     try {
    //         Swal.fire({
    //             title: 'Loading...',
    //             text: 'Please wait while the data is being processed.',
    //             allowOutsideClick: false,
    //             didOpen: () => {
    //                 Swal.showLoading();
    //             }
    //         });

    //         const requestData = {
    //             ReportName: reportName,
    //             PSG: psg?.MATSUBGROUP_CODE || 'ALL',
    //             Branch: branch?.BRANCH_CODE || 'ALL',
    //             Dealer: dealer?.DEALER_CODE || 'ALL',
    //             FinancialYear: selectedYear
    //         };

    //         const response = await axios.post(BASE_URL + '/warrentyconfigreport', requestData);
    //         if (response.data?.data && response.data.data.length > 0) {
    //             setTableData(response.data.data);
    //             setReportProcessed(true);
             
    //         } 
    //         else {
    //             setReportDataError('No Data Found for the selected options.');
    //         }
    //     } catch (err) {
    //         handleApiError(err);
    //     } finally {
    //         setLoading(false);
    //         Swal.close();
    //     }
    // };


    const fetchReportData = async () => {
        setLoading(true);
        setError("");
        try {
         
            Swal.fire({
                title: 'Loading...',
                text: 'Please wait...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });
    
        
            const requestData = {
                reportType: reportType,
                PSG: psg?.MATSUBGROUP_CODE || 'ALL',
                Branch: branch?.BRANCH_CODE || 'ALL',
                Dealer: dealer?.DEALER_CODE || 'ALL',
                FinancialYear: selectedYear
            };
    
            const response = await axios.post(BASE_URL + '/warrentyconfigreport', requestData);
    
          
            if (response.data?.data?.length > 0) {
                setTableData(response.data.data);
               
                setReportProcessed(true);
            } else {
              
                setReportProcessed(true);
               // setTableData('No Data Found for the selected options.');
            }
        } catch (err) {
       
            setError("An error occurred while fetching the data.");
        } finally {
            
            setLoading(false);
            Swal.close();
        }
    };
    const handleProcessReport = (e) => {
        e.preventDefault();
        if (!reportType || !psg || !branch || !selectedYear) {
            setError("Please fill all required fields.");
            return;
        }
        setError("");
        setReportProcessed(false);
        setTableData([]);
        setOpen(true);
        fetchReportData();
    };

    const handleExportReport = () => {
        if (tableData.length === 0) {
            Swal.fire({
                icon: 'info',
                text: 'No Data Available For export!',
            });
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to download the Excel file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, download it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const reportData = [
                    ["Dealer Warranty Report"],
                    [`Date: ${new Date().toLocaleDateString('en-US', {
                        month: 'long', day: 'numeric', year: 'numeric'
                    })}`],
                    [`Dealer: ${dealer ? dealer.DEALERNAME : "ALL"}`],
                    [],
                    ["ZONE", "BRANCH CODE", "CREATED ON", "PSG", "PSG DESCRIPTION", "WARRENT YDAYS", "EFFECTIVE FROM", "EFFECTIVE TO", "STATUS"],
                ];
                tableData.forEach(row => {
                    reportData.push([row.ZONE, row.BRANCHCODE, row.CREATEDON, row.PSG, row.PSGDESCRIPTION, row.WARRENTYDAYS, row.EFFECTIVE_FROM, row.EFFECTIVE_TO, row.STATUS]);
                });
                const ws = XLSX.utils.aoa_to_sheet(reportData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Transactions");
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: "application/octet-stream" });
                saveAs(data, "Dealer_Warranty_Report.xlsx");
            }
        });
    };

    useEffect(() => {
        fetchPsgOptions();
        fetchBranchOptions();
        fetchFinancialYears();
    }, []);

    return (
        <Container sx={{ padding: 0 }}>
        <div style={{ marginTop: '50px', width: '100%' }}>
            <Card sx={{ maxWidth: '100%', width: '100%', padding: 2, border: '1px solid #ccc', boxShadow: 3 }}>
                <CardContent>
                    <Stack direction="column" spacing={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    disablePortal
                                    options={['Branch Wise PSG Wise', 'Branch Wise Item Wise', 'Branch Wise Dealer Wise PSG']}
                                    value={reportType}
                                    onChange={(e, value) => setReportType(value)}
                                    renderInput={(params) => <TextField {...params} label="Report Type" />}
                                    style={{ width: '100%' }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    disablePortal
                                    options={psgOptions}
                                    value={psg}
                                    onChange={handlePsgChange}
                                    getOptionLabel={(option) => option.DESCRIPTION}
                                    renderInput={(params) => <TextField {...params} label="PSG" />}
                                    isOptionEqualToValue={(option, value) => option.MATSUBGROUP_CODE === value.MATSUBGROUP_CODE}
                                    style={{ width: '100%' }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    disablePortal
                                    options={branchOptions}
                                    value={branch}
                                    onChange={handleBranchChange}
                                    getOptionLabel={(option) => option.BRANCH_NAME}
                                    renderInput={(params) => <TextField {...params} label="Branch" />}
                                    style={{ width: '100%' }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    disablePortal
                                    options={financialYears}
                                    value={selectedYear}
                                    onChange={(e, newValue) => setSelectedYear(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Financial Year" />}
                                    style={{ width: '100%' }}
                                />
                            </Grid>
                        </Grid>
    
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                              
                                <Autocomplete
                                    disablePortal
                                    options={dealerOptions}
                                    value={dealer}
                                    onChange={handleDealerChange}
                                    getOptionLabel={(option) => option.DEALERNAME}
                                    renderInput={(params) => <TextField {...params} label="Dealer" />}
                                    style={{ width: '100%' }}
                                    disabled={reportType === 'Branch Wise PSG Wise'}
                                />
                            </Grid>
    
                            <Grid item xs={12} sm={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={handleProcessReport}
                                    sx={{
                                        width: '100%',
                                        backgroundColor: 'blue',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: 'darkblue',
                                        },
                                    }}
                                >
                                    VIEW
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={handleExportReport}
                                    sx={{
                                        width: '100%',
                                        backgroundColor: 'green',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: 'success',
                                        },
                                    }}
                                >
                                    Export Report
                                </Button>
                            </Grid>
                        </Grid>
    
                        {error && (
                            <Box style={{ color: 'red', textAlign: 'center' }}>
                                <Typography variant="body2">{error}</Typography>
                            </Box>
                        )}
                    </Stack>
                </CardContent>
            </Card>
        </div>
 
    

            {/* Report Table */}
            {reportProcessed && (
                <Grid item xs={12} sx={{ width: '100%' }}>
                    <TableContainer component={Paper} style={{ ...styles.tableContainer, height: '750px' }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={styles.headerCell}>ZONE</TableCell>
                                    <TableCell style={styles.headerCell}>BRANCH NAME</TableCell>
                                    <TableCell style={styles.headerCell}>CREATED ON</TableCell>
                                    <TableCell style={styles.headerCell}>PSG</TableCell>
                                    <TableCell style={styles.headerCell}>PSG DESCRIPTION</TableCell>
                                    <TableCell style={styles.headerCell}>WARRENTY DAYS</TableCell>
                                    <TableCell style={styles.headerCell}>EFFECTIVE FROM</TableCell>
                                    <TableCell style={styles.headerCell}>EFFECTIVE TO</TableCell>
                                    <TableCell style={styles.headerCell}>STATUS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length === 0 ?(
                                    <TableRow>
                                        <TableCell colSpan={9} style={{ textAlign: 'center', color: 'gray' }}>
                                           NO DATA FOUND
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    tableData.map((row, index) => (
                                        <TableRow key={index} style={styles.tableRow(index)}>
                                            <TableCell style={styles.bodyCell}>{row.ZONE}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.BRANCHCODE}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.CREATEDON}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.PSG}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.PSGDESCRIPTION}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.WARRENTYDAYS}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.EFFECTIVE_FROM}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.EFFECTIVE_TO}</TableCell>
                                            <TableCell style={styles.bodyCell}>{row.STATUS}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}

            {reportDataError && (
                <Box style={{ textAlign: 'center', marginTop: '20px' }}>
                    <Typography variant="h6" color="error">{reportDataError}</Typography>
                </Box>
            )}
        </Container>
    );
};

export default Report;


































